import { ModuleRegistry } from 'ag-grid-community';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { LicenseManager, SetFilterModule } from 'ag-grid-enterprise';
import './App.css';
import AppContent from './components/AppContent';
import { AuthProvider } from './context/AuthContext';
import { MicrosoftClarityProvider } from './context/MicrosoftClarityContext';

ModuleRegistry.registerModules([SetFilterModule]);
LicenseManager.setLicenseKey(
  process.env.REACT_APP_AG_GRID_LICENSE_KEY || 'your License Key'
);

// No global 403 interceptor needed — viewer write-blocked responses are handled

function App() {
  return (
    <div className="App">
      <MicrosoftClarityProvider
        projectId="tpijqh16u0"
        defaultUserConsent={true}
      >
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </MicrosoftClarityProvider>
    </div>
  );
}

export default App;
